"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
;
var Visible = (function (_super) {
    __extends(Visible, _super);
    function Visible(props) {
        return _super.call(this, props) || this;
    }
    Visible.prototype.render = function () {
        if (this.props.visible && this.props.children) {
            return React.createElement("span", null, this.props.children);
        }
        return null;
    };
    return Visible;
}(React.Component));
exports.Visible = Visible;



//////////////////
// WEBPACK FOOTER
// ./src/RenderEngine/VisibleRenderer.tsx
// module id = 210
// module chunks = 0